<template>
    <div class="container-fluid" v-if="tender.id > 0">
        <div class="row" v-if="!only_view">
            <div class="col-xl-8">
                <tender_time :now="date" :date-to="tender.date_to" :date-from="tender.date_from"></tender_time>
                
                <tender_header :tender="tender"></tender_header>
                <div id="panel-tender" class="panel">
                    <div   class="panel-hdr bg-primary-700 " >
                        <h2>
                            Заявка на тендер № {{ tender.number }} ({{tender.name}})
                        </h2>
                        <div class="panel-toolbar">
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
                        </div>
                    </div>
                    
                    <div class="panel-container collapse show">
                        <div class="panel-content">
                            <tender_request :tender="tender"></tender_request>
                            <tender_position :tender="tender"></tender_position>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-xl-4">
                <tender_info :tender="tender"></tender_info>
                <tender_payment :tender="tender"></tender_payment>
                <tender_files :tender="tender"></tender_files>
            </div>
        </div>
        
        <div class="row" v-if="only_view">
            <div class="col-xl-8">
                <div id="panel-tender" class="panel">
                    <div   class="panel-hdr bg-primary-700 " >
                        <h2>
                            Заявка на тендер № {{ tender.number }} ({{tender.name}})
                        </h2>
                        <div class="panel-toolbar">
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
                        </div>
                    </div>
                    
                    <div class="panel-container collapse show">
                        <div class="panel-content">
                            <application_reject :tender="tender"></application_reject>
                            <tender_position :only_view="only_view" :tender="tender"></tender_position>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-xl-4">
                <tender_time :now="date" :date-to="tender.date_to" :date-from="tender.date_from"></tender_time>
                <tender_header :tender="tender"></tender_header>
                <tender_info :tender="tender"></tender_info>
                <tender_payment :tender="tender"></tender_payment>
                <tender_files :tender="tender"></tender_files>
                
            </div>
            
        </div>
        
       
        
    </div>
</template>

<script>

import {
    BTabs,
    BTab,
    BOverlay,
    BSpinner,
    BButton,
    BButtonGroup
} from 'bootstrap-vue-next';

import tender_info from "./tabs/tender_info.vue";
import tender_time from "./tabs/tender_time.vue";
import tender_payment from "./tabs/tender_payment.vue";
import tender_files from "./tabs/tender_files.vue";
import tender_request from "./request/tender_request.vue";
import tender_header from "./tabs/tender_header.vue";
import Tender_position from "./tabs/tender_position.vue";
import Application_reject from "../../sale/applications/inside/blocks/application_reject.vue";

export default {
    name: "tender",
    props: {
        tender_id: {
            type: [Number, String],
            required: true
        },
        
        app_id : {
            type: [Number, String],
            default: 0
        },
        
        only_view_prop : {
            type : Boolean,
            default : false,
        },
        
        date : {
            type : String,
            required: true,
        },
        
    },
    
    components: {
        Application_reject,
        Tender_position,
        tender_files,
        tender_info,
        tender_time,
        tender_payment,
        tender_request,
        tender_header,
        
        
        BTab,
        BTabs,
        BOverlay,
        BSpinner,
        BButton,
        BButtonGroup,
    },
    
    data() {
        return {
            is_load: false,
            only_view : false,
            tender: {
                "app_id" : 0
            },
        }
    },
    
    created() {
        this.only_view = this.only_view_prop;
        this.loadTender();
        
        EventBus.$on('reload_app',this.loadTender);
    },
    
    methods: {
        async loadTender() {
            this.is_load = true;
            
            await api.get('/tenders/list/' + parseInt(this.tender_id) + "/with_app/" + this.app_id).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.tender = data.data;
                    this.tender.app_id = this.app_id;
        
                    if(this.tender.hasOwnProperty('status')) {
                        if (this.tender.status != 'published') {
                            this.only_view = true;
                        }
                    }
                    
                    if(!this.tender.hasOwnProperty("request")) {
                        this.tender.request = {
                            files : [],
                            payment : {},
                            positions : [],
                        }
                    }
                    else {
                        let request_status = this.tender.request?.status;
                        if(request_status !== 'new') {
                            this.only_view = true;
                        }
                    }
                    
                }
            }).catch(response => {
                console.log(response);
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    }
    
    
}
</script>


<style scoped>

</style>